import React from 'react';

import { Stack, Typography } from '@mui/material';

import ContentCard from '../../../components/ContentCard';
import { Class } from '../../../services/classes/types';
import { ExamTally } from '../types';

import ExamTallyRow from './index.styles';

type ExtendedClass = Class & {
  dayLabel: string;
  timeLabel: string;
  dayTimeLabel: string;
};

interface PayrollSummaryCardProps {
  validClasses: ExtendedClass[];
  examTally: ExamTally;
  markingDuration: number;
  tutorialDuration: number;
}

const PayrollSummaryCard = ({
  validClasses, examTally, markingDuration, tutorialDuration,
}: PayrollSummaryCardProps) => (
  <ContentCard variant="outlined" title="Payroll Summary">
    <Stack spacing={2}>
      <Typography>
        <b>Valid Classes</b>: {validClasses.length} {validClasses.length === 1 ? 'class' : 'classes'}
      </Typography>
      <Stack>
        <Typography>
          <b>Completed Marking</b>: {(markingDuration / 60).toFixed(2)} hour{(markingDuration / 60) === 1 ? '' : 's'}
        </Typography>
        {Object.values(examTally).map((examType) => (
          <ExamTallyRow key={examType.type} variant="caption">
            - {examType.count} x {examType.label} (
            {examType.unitPayDuration} mins / paper)<br />
          </ExamTallyRow>
        ))}
      </Stack>
      <Typography>
        <b>Completed Tutorials</b>: {tutorialDuration / 60} hour{(tutorialDuration / 60) === 1 ? '' : 's'}
      </Typography>
    </Stack>
  </ContentCard>
);

export default PayrollSummaryCard;
